import { request } from "../_helpers/Auth";

const namespace = "/api";

export const getCounters = () => {
    return request({
        url: namespace + "/counters",
        method: "get",
    });
};

export const getCounter = (counter_id) => {
    return request({
        url: namespace + "/counter/" + counter_id,
        method: "get",
    });
};

export const getUserCounters = (user_id) => {
    return request({
        url: namespace + "/counter/user/" + user_id,
        method: "get",
    });
};

export const createCounter = (payload) => {
    return request({
        url: namespace + "/counter",
        data: payload,
        method: "post",
    });
};

export const attachCounters = (user_id, compteurs_ids) => {
    return request({
        url: namespace + "/counter/attach",
        data: { user_id: user_id, compteurs_ids: compteurs_ids },
        method: "post",
    });
};

export const updateCounter = (counter_id, payload) => {
    return request({
        url: namespace + "/counter/" + counter_id,
        data: payload,
        method: "put",
    });
};

export const destroyCounter = (counter_id) => {
    return request({
        url: namespace + "/counter/" + counter_id,
        method: "delete",
    });
};

export const addMouvement = (counter_id, payload) => {
    return request({
        url: namespace + "/mouvement/" + counter_id,
        data: payload,
        method: "put",
    });
};

export const hideMouvement = (mouvement_id, payload) => {
    return request({
        url: namespace + "/mouvement/" + mouvement_id,
        data: payload,
        method: "delete",
    });
};

export const getMouvementsByUserAndCounter = (user_id, counter_id, page = 1, per_page = 10) => {
    return request({
        url: namespace + "/mouvements/" + user_id + "/" + counter_id,
        method: "get",
        params: { page, per_page },
    });
};